<template>
  <div class="edit-video-box">
    <el-dialog
      :title="title1"
      :visible.sync="dialogVisible"
      width="350px"
      :before-close="handleClose"
      :close-on-click-modal="false"
      append-to-body
    >
      <el-form
        ref="form"
        :model="params"
        :rules="rules"
        label-width="90px"
        :label-position="labelPosition"
      >
        <el-form-item label="回执信息:" prop="processedReceipt">
          <el-input
            v-model="params.processedReceipt"
            size="small"
            type="textarea"
            :rows="4"
            placeholder="回执信息"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align:center">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')" :loading="flag" size="small">确 认</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import API from "@/api";
export default {
  data() {
    return {
      labelPosition: "left",
      dialogVisible: false,
      title1: "",
      type: "",
      flag: false,
      id: "",
      // 审核通过/拒绝 表单数据
      params: {
        processedReceipt: "",
        processingStatus:''
      },

      // 表单验证规则
      rules: {
        processedReceipt: [
          { required: true, message: "请填写回执信息", trigger: "blur" },
        ],
      },
    };
  },

  methods: {
    // 表单验证提交
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.flag = true;
          if (this.type === "pass") {
            this.passReview();
          } else {
            this.refuseReview();
          }
        } else {
          return false;
        }
      });
    },
    // 通过
    passReview() {
      let params = Object.assign({}, this.params, {
        id: this.id,
        processingStatus:1
      });
      API.updateErrFeedback(params)
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "操作成功",
              type: "success",
            });
            this.$emit("handlerAgentList");
          } else {
            if (res.tip) {
              this.$message.error(res.tip);
            } else {
              this.$message.error("操作失败");
            }
          }
          this.handleClose();
          this.flag = false;
        })
        .catch(() => {
          this.handleClose();
          this.flag = false;
        });
    },
    // 拒绝
    refuseReview() {
      let params = Object.assign(
        {},
        { id: this.id,
         processedReceipt: this.params.processedReceipt,processingStatus:2
       }
      );
      API.updateErrFeedback(params)
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "操作成功",
              type: "success",
            });
            this.$emit("handlerAgentList");
          } else {
            if (res.tip) {
              this.$message.error(res.tip);
            } else {
              this.$message.error("操作失败");
            }
          }
          this.handleClose();
          this.flag = false;
        })
        .catch(() => {
          this.handleClose();
          this.flag = false;
        });
    },

    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.$refs.form.resetFields();
      this.params = {
        processedReceipt: "",
        processingStatus:''
      };
    },
    // 打开编辑视频弹窗、传递需要编辑的参数
    open(type, data) {
      this.dialogVisible = true;
      this.type = type;
      this.id = data.id;
      if (type === "pass") {
        this.title1 = "回复操作";
          window.console.log(data.processedReceipt,'data.processedReceipt')
        this.params.processedReceipt =( data.processedReceipt&& data.processedReceipt!=='')?data.processedReceipt:'已处理，感谢你提出的宝贵意见！';
        this.params.processingStatus = data.processingStatus;
      } else {
        this.title1 = "忽略操作";
        this.params.processedReceipt='请耐心等待！'
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.edit-video-box {
  .item-box {
    margin-left: 28px;
    width: 100%;
    display: flex;
    .item1 {
      flex: 1;
      .upload {
        position: relative;
        top: 35px;
        left: -90px;
      }
    }
    .item2 {
      flex: 3;
      width: 250px;
      position: relative;
      top: 0px;
      left: -60px;
    }
  }
}
</style>
